import { render, staticRenderFns } from "./SharedPastes.vue?vue&type=template&id=405758bc&scoped=true&"
import script from "./SharedPastes.vue?vue&type=script&lang=js&"
export * from "./SharedPastes.vue?vue&type=script&lang=js&"
import style0 from "./SharedPastes.vue?vue&type=style&index=0&id=405758bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405758bc",
  null
  
)

export default component.exports